import { QueryClient } from 'react-query';

const client = new QueryClient();

export default client;
